module.exports = __webpack_public_path__ + "img/icon.2f8cf3d1.svg";